import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { EmptyNameEmailPage } from './empty-name-email.page';

const routes: Routes = [
  {
    path: '',
    component: EmptyNameEmailPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [EmptyNameEmailPage]
})
export class EmptyNameEmailPageModule {}
